import logo from '../../assets/images/logo.png'

const Logo = () => {
  return <img width={350} src={logo} alt="Skaderapportering" />
}

export { Logo }
